import { GOAL_COUNTS_URL } from './urls';

export const GOAL_COUNTS_MAIN_TITLE = `Para lograr tus metas, te ayudamos como <b>hacer crecer tu dinero.</b>`;

export const GOAL_COUNTS_MAIN_SUBTITLE = 'Conoce nuestra Cuenta Metas';

const GOAL_COUNTS_ANNUALIZED_RETURN = 7.82;

export const GOAL_COUNTS_INFORMATION_LIST = [
  `Es una cuenta de aportes voluntarios <b>distinta a la de tu fondo de pensión.</b>`,
  `Es de <b>libre disponibilidad</b>, por lo que puedes realizar retiros ilimitados.`,
  `Invierte <b>sin un periodo mínimo de permanencia.</b>`,
  `Tu dinero crece con una <b>rentabilidad anual de <span>${ GOAL_COUNTS_ANNUALIZED_RETURN }%*</span></b>`,
]

export const GOAL_COUNTS_DOWNLOAD_TEXT = `<a href="${GOAL_COUNTS_URL}" target="_blank" rel="noopener noreferrer">Descarga la cartilla informativa de APV</a>`;

export const GOAL_COUNTS_FOOTNOTES = [
  {
    nRef: '*',
    text: 'Rentabilidad promedio del Fondo 2 (Fuente SBS - Promedio histórico mar 2006 - mar 2023).'
  },
  {
    nRef: '**',
    text: 'El valor de las inversiones de los distintos tipos de fondos de aportes voluntarios (Cuenta Metas) es variable, por lo tanto, el nivel de la rentabilidad futura puede variar en relación con la rentabilidad pasada, pudiendo incluso presentarse escenarios de volatilidad en los que se afecte el capital invertido. Prima AFP no garantiza el pago de intereses o la obtención de rentabilidad positiva sobre la inversión efectuada.'
  }
];
